import axios from 'axios';
import { getKjederegAdminApiUrl } from '../../';
import {
  DagligvareOmsetningImportResponse,
  OmsetningBatchEnhetDto,
  OmsetningBatchResponse,
  UpdateOmsetningBatchEnhetRequest,
} from './types';

const baseUrl = getKjederegAdminApiUrl() + '/DagligvareOmsetning';

const DagligvareOmsetningApi = {
  import: async (file: File): Promise<DagligvareOmsetningImportResponse> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post<DagligvareOmsetningImportResponse>(
      `${baseUrl}/Import`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    );
    return response.data;
  },

  importBatch: async (file: File): Promise<OmsetningBatchResponse> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post<OmsetningBatchResponse>(`${baseUrl}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  getBatch: async (): Promise<OmsetningBatchResponse> => {
    const response = await axios.get<OmsetningBatchResponse>(`${baseUrl}/batch`);
    return response.data;
  },

  updateEnhet: async (
    enhetId: number,
    req: UpdateOmsetningBatchEnhetRequest,
  ): Promise<OmsetningBatchEnhetDto> => {
    const response = await axios.put<OmsetningBatchEnhetDto>(
      `${baseUrl}/batch/enheter/${enhetId}`,
      req,
    );
    return response.data;
  },

  publishBatch: async (): Promise<OmsetningBatchResponse> => {
    const response = await axios.post<OmsetningBatchResponse>(`${baseUrl}/batch/publish`);
    return response.data;
  },

  deleteBatch: async (): Promise<void> => {
    await axios.delete(`${baseUrl}/batch`);
  },
};

export default DagligvareOmsetningApi;
